import {
    Button,
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
} from "@chakra-ui/react";
import { FC, useContext, useEffect, useState } from "react";
import { useRodo } from "../../../../hooks/useRodo";
import { useIsComponentMounted } from "../../../../hooks/useIsMounted";
import {LoginStateContext} from "../../LoginState";
import { useQueryClient } from 'react-query';
import { deleteJSON } from "../../../../api/http";
import { endpoints } from "../../../../api/endpoints";


export interface IRodoModal {
    onCloseModal?: Function;
}

export const RodoModal: FC<IRodoModal> = ({ onCloseModal }) => {
    const { isOpen, onOpen, onClose } = useDisclosure(),
        onFormClose = () => {
            if (data && !data.force_accept) {
                onClose();
            }
            if (onCloseModal) {
                onCloseModal()
            }
        },
        [accepted, setAccepted] = useState<boolean>(false),
        isMounted = useIsComponentMounted(),
        { data, acceptRodo } = useRodo(onClose),
        { dispatch } = useContext(LoginStateContext),
        queryClient = useQueryClient(),
        deleteLogout = async () => deleteJSON(endpoints.auth),
        onSubmit = () => {
            acceptRodo();
        },
        handleLogout = () => {
            deleteLogout();
            queryClient.invalidateQueries();
            queryClient.cancelQueries();
            queryClient.clear();
            dispatch({ type: 'NOT_LOGGED' });
        };

    useEffect(() => {
        if (!isOpen) {
            onOpen();
        }
    }, [data]);

    return (
        <Modal isOpen={isOpen} onClose={onFormClose} closeOnOverlayClick={false} >
            <ModalOverlay onClick={onFormClose} />
            <ModalContent minW={["100%", "100%", "500px"]}
                minH={["100%", "100%", "initial"]}
                m={["0px", "0px", "60px 0px"]}
                borderRadius={["0px", "0px", "10px"]}>
                <ModalHeader color="darkPrimary">Klauzula RODO</ModalHeader>
                {/* {data && !data.force_accept && <ModalCloseButton fontSize={["20px", "20px", "12px"]}
                m={["10px", "10px", "0px"]} />J
                
                } */}
                <ModalCloseButton onClick={handleLogout} />
                <ModalBody>
                    {data &&
                        <div dangerouslySetInnerHTML={{ __html: data.html }} />
                    }
                </ModalBody>
                <ModalFooter>
                    <Flex justifyContent="center"
                        w="100%"
                        flexDir={["column-reverse", "column-reverse", "row"]}>
                        <Button backgroundColor="lightPrimary"
                            _hover={{ backgroundColor: "lighterPrimary" }}
                            color="white"
                            p="10px 30px"
                            size="sm"
                            h="35px"
                            onClick={() => {
                                onFormClose()
                                onSubmit()
                            }}>
                            Akceptuję
                        </Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
